import AboutUsSection from "../../components/aboutUsSection/AboutUsSection";
import Counter from "../../components/counter/Counter";
import LastSection from "../../components/lastSection/LastSection";
import Section2About from "../../components/section2About/Section2About";
import ServicesTabs from "../../components/servicesTabs/ServicesTabs";
import { useEffect } from "react";
import "./About.css";
export default function About() {
  function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: "smooth" // Smooth scrolling animation
    });
  }
  
  
  useEffect(() => {
    scrollToTop();
  }, []);
  return (
    <>
      <AboutUsSection
        head={"من نحن؟"}
        heading={" لكل نجاح "}
        heading2={"حكاية تروى"}
        slog={
"اكتشف طريقك في العقارات في مدينةجدة واستعرض تاريخنا الزاخر بالإنجازات ورضا العملاء منذ بدايتنا."        }
      />
      <Counter />
      <Section2About />
      <ServicesTabs
        styling={false}
        heading={" باقة خدماتنا المميزة"}
        heading2={"مصممة خصيصًا لك"}
        desc={
          "أبعاد شريكك الموثوق من الشراء إلى البيع، الاستثمار لإدارة العقارات، نحن هنيّة بخدمتك"
        }
      />
      <LastSection />
    </>
  );
}
